"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_ui_1 = require("@pasport/react-ui");
const FileUploadModal = ({ show, onClose, onSuccess, dispatchFileUpload, strings, fileFormat }) => {
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const [selectedFile, setSelectedFile] = (0, react_1.useState)(undefined);
    const [fileName, setFileName] = (0, react_1.useState)("");
    const handleFileChange = (e) => {
        const file = e?.target?.files?.[0];
        setSelectedFile(file);
    };
    const handleNameChange = (e) => {
        setFileName(e.target.value);
    };
    const handleSuccess = () => {
        if (onSuccess)
            onSuccess();
    };
    const handleSubmit = async () => {
        setIsSubmitting(true);
        if (selectedFile) {
            const name = fileName.trim();
            const response = await dispatchFileUpload({
                file: selectedFile,
                name: name ? name : selectedFile.name
            });
            // const response = await fetchUploadFile(selectedFile, {
            //     PXname: name ? name : selectedFile.name,
            //     ...uploadOptions
            // })
            if (response.error) {
                alert(`Při nahrávání se objevila chyba: ${response.error.message}`);
            }
            else {
                handleSuccess();
            }
        }
        setIsSubmitting(false);
    };
    (0, react_1.useEffect)(() => {
        setSelectedFile(undefined);
    }, [show]);
    (0, react_1.useEffect)(() => {
        setFileName(selectedFile?.name ? selectedFile.name : "");
    }, [selectedFile]);
    return ((0, jsx_runtime_1.jsx)(react_ui_1.Modal, { show: show, onClose: onClose, children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h4", { className: "fw-bold", children: strings.title }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { className: "mb-3", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "formFile", className: "form-label", children: strings.subtitle }), (0, jsx_runtime_1.jsx)("input", { className: "form-control", type: "file", id: "formFile", accept: fileFormat, disabled: isSubmitting, onChange: handleFileChange }), selectedFile && ((0, jsx_runtime_1.jsxs)("div", { className: "pt-3", children: [(0, jsx_runtime_1.jsx)("div", { className: "d-flex justify-content-between", children: (0, jsx_runtime_1.jsx)("label", { htmlFor: 'doc-name', className: "form-label mb-1", children: (0, jsx_runtime_1.jsx)("span", { children: "Pojmenujte soubor" }) }) }), (0, jsx_runtime_1.jsx)("input", { className: "form-control", id: "doc-name", type: "text", value: fileName, disabled: isSubmitting, onChange: handleNameChange })] }))] }), (0, jsx_runtime_1.jsx)("div", { className: "text-end", children: isSubmitting ? ((0, jsx_runtime_1.jsx)("span", { className: "fw-bold text-success", children: strings.uploading })) : ((0, jsx_runtime_1.jsx)("button", { className: "btn btn-success fw-bold", type: "button", onClick: handleSubmit, disabled: !selectedFile || isSubmitting || fileName.trim() === "", children: strings.uploadButton })) })] })] }) }));
};
exports.FileUploadModal = FileUploadModal;
